export default "__VITE_ASSET__CsvjbCq7__"